import React, { Fragment } from "react";
import styled from "@emotion/styled";
import {
  ButtonT2,
  ButtonT7,
  FileUploadButtonT1,
} from "Components/Common/Button/index";
import { ReactComponent as DownloadIconT1 } from "Icons/downloadIconT1.svg";

const ShipmentFileUploadAndDownloadSection = (props) => {
  const {
    handleDownloadEximCargoTemplateFile,
    eximCargoTemplateFileName,
    handleOnChangeForEximCargoTemplateFile,
    handleOnClickUploadForEximCargoTemplateFile,
  } = props;
  return (
    <Fragment>
      <ShipmentFileUploadAndDownloadSectionWrapper>
        <ButtonT2 onClick={handleDownloadEximCargoTemplateFile}>
          <DownloadIconT1 />
          Template
        </ButtonT2>

        <FileUploadButtonT1
          accept=".xlsx, .xls"
          fileName={eximCargoTemplateFileName}
          onChange={handleOnChangeForEximCargoTemplateFile}
        />

        <ButtonT7 onClick={handleOnClickUploadForEximCargoTemplateFile}>
          Upload
        </ButtonT7>
      </ShipmentFileUploadAndDownloadSectionWrapper>
    </Fragment>
  );
};

export default ShipmentFileUploadAndDownloadSection;

const ShipmentFileUploadAndDownloadSectionWrapper = styled("div")`
  border-radius: 5px;
  border: 1px solid #48525e;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(98, 127, 233, 0.25);
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;
